
<b-container>
  <b-row>
    <b-col sm="12" md="12" lg="6" xl="4" v-for="category_assignment in sorted_category_assignments" :key="category_assignment.id">
      <b-card>
        <b-card-title class="mb-3">
          {{category_assignment.title}}
        </b-card-title>
        <b-card-sub-title class="mb-3">
          {{category_assignment.subtitle}}
        </b-card-sub-title>
        <b-card-text>
          {{category_assignment.text}}
          <div v-if="bullets(category_assignment).length > 0">
            <ul class="mt-3">
              <li v-for="item in bullets(category_assignment)">{{item}}</li>
            </ul>
          </div>
        </b-card-text>
        <b-button variant="primary" v-on:click="selectBtoTemplate(category_assignment.cfg_template_id)">Configure</b-button>
      </b-card>
    </b-col>
  </b-row>
</b-container>
